export default function (value: any): boolean {
  return typeof value === 'function'
}
